export const Step = {
    Intro: 0,
    Challenges: 1,
    Services: 2,
    Workshop: 3,
    Technologies: 4,
    Estimate: 5,
    Success: 6,
} as const;

export type StepValue = (typeof Step)[keyof typeof Step];

export const WIZARD_STEPS_COUNT = 6;

export const STEP_NAMES: Record<number, string> = {
    [Step.Intro]: 'intro',
    [Step.Challenges]: 'challenges',
    [Step.Services]: 'services',
    [Step.Workshop]: 'workshop',
    [Step.Technologies]: 'technologies',
    [Step.Estimate]: 'estimate',
    [Step.Success]: 'success',
};
